import React from "react";
import { connect } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { StoreState } from "../../redux/configure-store";
import AccountDropdown from "./account-dropdown";
import { logout } from "../../authentication/authentication-actions";
import { navigateToSettingsPage } from "../user-actions";
import { primary } from "../../theme/theme";

const DRAWER_WIDTH = 240;
const COLLAPSED_DRAWER_WIDTH = 72;

interface TopBarProps {
  isMenuDrawerOpen: boolean;
  userFirstName?: string | null;
  userLastName?: string | null;
  userProfileImage?: string | null;
  logout: () => void;
  navigateToSettingsPage: () => void;
}

const TopBar = (props: TopBarProps) => {
  const {
    isMenuDrawerOpen,
    logout,
    navigateToSettingsPage,
    userFirstName,
    userLastName,
    userProfileImage,
  } = props;

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "white",
        borderBottom: `2px solid ${primary.main}`,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        ...(isMenuDrawerOpen && {
          marginLeft: `${DRAWER_WIDTH}px`,
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          transition: (theme) =>
            theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
        }),
        ...(!isMenuDrawerOpen && {
          marginLeft: `${COLLAPSED_DRAWER_WIDTH}px`,
          width: `calc(100% - ${COLLAPSED_DRAWER_WIDTH}px)`,
        }),
      }}
    >
      <Toolbar
        sx={{
          px: { xs: 2, sm: 3 },
          minHeight: { xs: 56, sm: 64 },
        }}
      >
        {/* Page Title / Branding */}
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: 1,
            color: "text.primary",
            fontWeight: 600,
            display: { xs: "none", sm: "block" },
          }}
        >
          DoneStreet
        </Typography>

        {/* Spacer for mobile */}
        <Box sx={{ flexGrow: 1, display: { xs: "block", sm: "none" } }} />

        {/* Account Dropdown */}
        <AccountDropdown
          userFirstName={userFirstName}
          userLastName={userLastName}
          userProfileImage={userProfileImage}
          logoutClick={logout}
          settingsClick={navigateToSettingsPage}
        />
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = (storeState: StoreState) => ({
  user: storeState.authentication.user,
  userProfileImage:
    storeState.authentication.user &&
    storeState.authentication.user.profileImageUrl,
  userFirstName:
    storeState.authentication.user && storeState.authentication.user.firstName,
  userLastName:
    storeState.authentication.user && storeState.authentication.user.lastName,
  isMenuDrawerOpen: storeState.user.isMenuDrawerOpen,
});

export default connect(mapStateToProps, {
  logout,
  navigateToSettingsPage,
})(TopBar);
